import { render, staticRenderFns } from "./Pilatus.vue?vue&type=template&id=31d2a0a0&"
import script from "./Pilatus.vue?vue&type=script&lang=js&"
export * from "./Pilatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Pilatus.vue"
export default component.exports